import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";
import { Menu, X, Instagram } from "lucide-react";

const links = [
  { label: "Services", to: "/#services" },
  { label: "Books", to: "/#books" },
  { label: "Community", to: "/#community" },
  { label: "Courses", to: "/dashboard" },
];

const LOGO = "https://customer-assets.emergentagent.com/job_strategy-hub-236/artifacts/m6vj62st_12908.jpg";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 bg-[#0B0C10]/80 backdrop-blur-xl border-b border-white/5"
      data-testid="navbar"
    >
      <div className="px-6 md:px-12 lg:px-24 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="navbar-logo">
          <img src={LOGO} alt="Martin Ramnarine LLC" className="h-12 w-12 object-contain rounded-sm" />
          <span className="hidden sm:block font-display text-[15px] tracking-[0.18em] text-white uppercase">Martin Ramnarine LLC</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a key={l.label} href={l.to} className="text-sm text-[#9CA3AF] hover:text-white transition-colors tracking-wide"
               data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          {user ? (
            <>
              {user.role === "admin" && pathname !== "/admin" && (
                <Link to="/admin" className="text-sm text-[#D4AF37] hover:text-[#F1D570] tracking-wide" data-testid="nav-admin">Admin</Link>
              )}
              <span className="text-sm text-[#9CA3AF]">{user.name?.split(" ")[0]}</span>
              <button onClick={logout} className="text-sm text-[#9CA3AF] hover:text-white" data-testid="nav-logout">Sign out</button>
            </>
          ) : (
            <Link to="/login" className="text-sm text-[#9CA3AF] hover:text-white tracking-wide" data-testid="nav-login">Member Login</Link>
          )}
          <a href="https://instagram.com/martinramnarinellc" target="_blank" rel="noopener noreferrer"
             className="text-[#9CA3AF] hover:text-[#D4AF37] transition-colors" aria-label="Instagram" data-testid="nav-instagram">
            <Instagram size={20} />
          </a>
          <a href="/#inquiry" className="bg-[#D4AF37] text-[#0B0C10] font-medium hover:bg-[#F1D570] transition-colors rounded-sm px-6 py-2.5 text-sm"
             data-testid="nav-cta">Free Consultation</a>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#0B0C10] px-6 py-6 space-y-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a key={l.label} href={l.to} onClick={() => setOpen(false)} className="block text-[#9CA3AF] hover:text-white">{l.label}</a>
          ))}
          {user ? (
            <>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="block text-[#D4AF37]">Admin</Link>}
              <button onClick={() => { setOpen(false); logout(); }} className="block text-[#9CA3AF]">Sign out</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)} className="block text-[#9CA3AF]">Member Login</Link>
          )}
          <a href="https://instagram.com/martinramnarinellc" target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="flex items-center gap-2 text-[#9CA3AF] hover:text-[#D4AF37]" data-testid="nav-mobile-instagram">
            <Instagram size={18} /> @martinramnarinellc
          </a>
          <a href="/#inquiry" onClick={() => setOpen(false)} className="block bg-[#D4AF37] text-[#0B0C10] text-center font-medium rounded-sm px-6 py-3">Free Consultation</a>
        </div>
      )}
    </header>
  );
}
